exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup[data-v-6559b114]{position:fixed;top:0;left:0;z-index:9999;width:100%;height:100%;opacity:0;pointer-events:none;-webkit-transition:all .2s;transition:all .2s}.popup.active[data-v-6559b114]{opacity:1;pointer-events:auto}.popup .popup-mask[data-v-6559b114]{position:absolute;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.8)}.popup .popup-content[data-v-6559b114]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports
